import Rails from "@rails/ujs"
import "channels"

import '../sitemap_page/css/notosansjapanese.css'
import '../sitemap_page/css/cmn_layout.css'
import '../sitemap_page/css/cmn_style.css'
import '../sitemap_page/css/index.css'

const images = require.context('../sitemap_page/images', true)

import 'jquery'
import 'bxslider/dist/jquery.bxslider.min.js'
import '../sitemap_page/js/common'
import '../sitemap_page/js/f(1)'
import '../sitemap_page/js/s_retargeting'
import '../sitemap_page/js/conversion'
import '../sitemap_page/js/tag'
import '../sitemap_page/js/analytics'
import '../sitemap_page/js/js'
import '../sitemap_page/js/f'


Rails.start()

window.jQuery = $;
window.$ = $;
